<template>
  <div class="view view-onboarding">
    <form class="view-onboarding__form" @submit.prevent="submit">
      <logo class="view-onboarding__logo" />

      <div class="mt-4 ta-center">
        <h2>{{ $t("heading.profileOnboarding") }}</h2>
        <p>
          {{ $t("texts.profileOnboarding") }}
        </p>
      </div>

      <div class="column">
        <input-text
          v-model:value="data.firstname"
          :label="$t('labels.firstname')"
          :required="true"
        />
        <input-text
          v-model:value="data.lastname"
          :label="$t('labels.lastname')"
          :required="true"
        />

        <p v-if="data.error" class="message-error">
          {{ data.error }}
        </p>
      </div>

      <button type="submit" class="button mt-4">
        {{ $t("actions.saveAndStart") }}
      </button>
    </form>
  </div>
</template>

<script setup lang="ts">
import { reactive, computed } from "vue";
import { useRoute, useRouter } from "vue-router";

import Logo from "@core/ui/SimcisionLogo.vue";
import InputText from "@core/input/InputText.vue";
import { useUser } from "@/api/user.store";
import { showError } from "@core/ui/alert/alert";

const route = useRoute();
const router = useRouter();
const { user, updateUser } = useUser();

const data = reactive({
  firstname: user.value?.firstname,
  lastname: user.value?.lastname,
  error: ""
});

const redirectPath = computed(() => {
  if (route.redirectedFrom) {
    return {
      path: route.redirectedFrom.path,
      params: route.redirectedFrom.params
    };
  }
  return {
    name: "models-explorer"
  };
});

async function submit() {
  if (!user.value) {
    showError("No user found");
    return;
  }

  try {
    await updateUser({
      id: user.value.id,
      firstname: data.firstname,
      lastname: data.lastname
    });

    router.push(redirectPath.value);
  } catch (e) {
    const error = e as Error;
    data.error = error.message;
    console.log(error);
  }
}
</script>

<style lang="scss">
.view-onboarding {
  display: flex;
  padding: 2rem;

  &__form {
    display: flex;
    flex-direction: column;
    margin: auto;
    width: 100%;
    max-width: 32rem;
  }

  &__logo {
    margin: 0 auto;
  }
}
</style>
